import { render, staticRenderFns } from "./pos-patients-add-edit-dialog.vue?vue&type=template&id=790e52a0&scoped=true"
import script from "./pos-patients-add-edit-dialog.vue?vue&type=script&lang=js"
export * from "./pos-patients-add-edit-dialog.vue?vue&type=script&lang=js"
import style0 from "./pos-patients-add-edit-dialog.vue?vue&type=style&index=0&id=790e52a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790e52a0",
  null
  
)

export default component.exports